import React from 'react';

import { prop } from 'ramda';

import { FOHView } from '../../ingredients';

import { FOHSelectButtonCell } from '../cells/FOHSelectButtonCell';

import { FOHSelectItemProps } from './FOHSelect';

export interface FOHMultiSelectButtonsProps {
  options: Array<FOHSelectItemProps>;
  selected?: Array<string>;
  selectItem: (val: string) => void;
  section?: string;
}

export const FOHMultiSelectButtons = (props: FOHMultiSelectButtonsProps) => (
  <FOHView style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
    {props.options.map(item => (
      <FOHSelectButtonCell
        key={item.value}
        value={item.value}
        onPress={props.selectItem}
        label={item.label}
        section={props.section || ''}
        selected={
          props.selected && props.selected.includes(prop('value', item))
            ? true
            : false
        }
      />
    ))}
  </FOHView>
);
